const requestStatus = {
  REQUEST_NOT_INITIATED: 0,
  REQUEST_IN_PROGRESS: 1,
  REQUEST_COMPLETED: 2,
};

export default requestStatus;
